import { DomainSubject } from "./domainSubject";
import { logUtil } from "@repo/lib-common";

export class DomContentLoadedSubject extends DomainSubject<Event> {

    name = "DomContentLoadedSubject";
    init = () => {
        logUtil.consoleLog("DomContentLoadedSubject init called");
        if (document.readyState === "complete") {
            logUtil.consoleLog("DomContentLoadedSubject fail-safe triggered when readyState:", document.readyState);
            this.trigger();
            return;
        }
        logUtil.consoleLog("DomContentLoadedSubject registered when readyState:", document.readyState);
        document.addEventListener("DOMContentLoaded", (event) => {
            logUtil.consoleLog("DOMContentLoaded event:", event);
            this.trigger();
        });
        return;



    }

}

const domContentLoadedSubject = new DomContentLoadedSubject();
domContentLoadedSubject.activate();

export { domContentLoadedSubject };




